'use strict';

/**
 * @ngdoc Class
 * @name mx.SolutionBuilderAgent.EditFormViewLocals
 *
 * @description
 * Input attributes for controller of EditFormView
 *
 * @param {Object} options - display name of the edit-form view
 *
 */
export default class EditFormViewLocals {
	constructor(options) {
		Object.defineProperties(this, {
			objectId: {
				enumerable: true,
				value: options.objectId,
			},
			item: {
				enumerable: true,
				value: options.item,
			},
			mxServiceContext: {
				enumerable: true,
				value: options.mxServiceContext,
			},
			templateId: {
				enumerable: true,
				value: options.templateId,
			},
			dataModel: {
				enumerable: true,
				value: options.dataModel,
			},
			cancelLabel: {
				enumerable: true,
				value: options.cancelLabel || 'cancel',
			},
			saveLabel: {
				enumerable: true,
				value: options.saveLabel || 'save',
			},
			__localizationModeEnabled: {
				enumerable: true,
				value: options.__localizationModeEnabled,
			},
			localizationData: {
				enumerable: true,
				value: options.localizationData,
			},
			readOnly: {
				enumerable: true,
				value: options.readOnly,
			},
			disabled: {
				enumerable: true,
				value: options.disabled,
			},
		});
	}
}
